<template>
  <ConclusionStep
    status="positive"
    :title="conclusionTitle"
    :description="conclusionSubtitle"
    @close="goHome"
    @onAnimationStart="startAnimation"
  >
    <ContentDisplay content-aspect="outside">
      <template #content-block-1>
        <HeadingDisplay size="extra-small" title="Transferência via TED" />
        <ListDisplay title="Valor" :value="`R$ ${amountValue}`" />
        <ListDisplay
          title="Instituição"
          :value="selectedBankAccount.bankName"
        />
        <ListDisplay
          title="Agência"
          :value="selectedBankAccount.agency.formatted"
        />
        <ListDisplay
          title="Conta com dígito"
          :value="selectedBankAccount.accountNumber.formatted"
        />
        <ListDisplay
          title="Tipo de conta"
          :value="selectedBankAccount.accountType.formatted"
        />
      </template>
    </ContentDisplay>
    <template #button-primary>
      <ButtonPrimary label="Voltar para a home" size="large" @click="goHome" />
    </template>
  </ConclusionStep>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  ConclusionStep,
  ContentDisplay,
  HeadingDisplay,
  ListDisplay,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { ETransferType } from '@/modules/transaction/views/NewTransfer/helpers/types';
import { IBankAccount } from '@/modules/transaction/services/new-transfer';
import * as trackEvents from '@/modules/transaction/views/NewTransfer/track-events';

@Component({
  components: {
    ConclusionStep,
    ContentDisplay,
    HeadingDisplay,
    ListDisplay,
    ButtonPrimary
  }
})
export default class NewTransferConclusion extends Vue {
  @Prop({ type: String, required: true })
  readonly transferType!: ETransferType;

  @Prop({ type: String, required: true })
  readonly amountValue!: string;

  @Prop({ type: Object, required: true })
  readonly selectedBankAccount!: IBankAccount;

  @Prop({ type: String, required: false })
  readonly scheduleDescription?: string;

  get conclusionTitle() {
    return this.transferType === ETransferType.SCHEDULE
      ? 'Transferência agendada'
      : 'Transferência solicitada';
  }

  get conclusionSubtitle() {
    return this.transferType === ETransferType.SCHEDULE
      ? this.scheduleDescription
      : '';
  }

  goHome() {
    trackEvents.trackScheduleTransferSuccessDetailsBackClick();
    this.$router.push({ name: 'home' });
  }

  startAnimation() {
    if (this.transferType === ETransferType.SCHEDULE)
      trackEvents.trackScheduleTransferSuccessLoad();
  }
}
</script>

<style lang="less" scoped>
.content-display {
  padding-bottom: @size-spacing-x300;
}

.heading-display {
  margin-bottom: @size-spacing-x500;
}

.list-display {
  margin-bottom: @size-spacing-x400;
}
</style>
